import { useDataProvider, useNotify } from "react-admin";
import React from "react";
import { StyledButton } from "../../../components/ListShowButton";

const ShowPdfButton = (props: any) => {
  const provider = useDataProvider();
  const notify = useNotify();

  const GetPdf = (id: number) => {
    provider
      .getOne("customerReceipts", {
        id: id,
      })
      .then(({ data }) => {
        window.open(data.pdfUrl, "_blank");
      })
      .catch(() => {
        notify("PDF is generating...");
      });
  };

  return (
    <>
      <StyledButton
        variant="outlined"
        onClick={() => {
          GetPdf(props.data.id);
        }}
      >
        Show PDF
      </StyledButton>
    </>
  );
};

export default ShowPdfButton;
